/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CompanyFromJSON, CompanyToJSON } from './Company';
import { ContactFromJSON, ContactToJSON } from './Contact';
export function GetContactResponseDataFromJSON(json) {
    return GetContactResponseDataFromJSONTyped(json, false);
}
export function GetContactResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contact: !exists(json, 'contact') ? undefined : ContactFromJSON(json['contact']),
        company: !exists(json, 'company') ? undefined : CompanyFromJSON(json['company'])
    };
}
export function GetContactResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contact: ContactToJSON(value.contact),
        company: CompanyToJSON(value.company)
    };
}
